import { getNotifications } from '../../redux/slices/user';
import { store } from '../../redux/store';
import axios from '../../common/axios';
import type { ApiResult } from '../../@types/api';
import { slice } from './slice';
import type { PendingInvitation } from './types';

export async function getMyPendingInvitations(): Promise<PendingInvitation[]> {
  const response = await axios.get('invitations/me');
  return response.data;
}

// Actions
export function getInvitations(pathwayGuid: string) {
  return async () => {
    const { dispatch } = store;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`invitations/${pathwayGuid}`);
      dispatch(slice.actions.getInvitations(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    } finally {
      dispatch(slice.actions.stopLoading());
    }
  };
}

export function acceptInvitation(guid: string) {
  return async () => {
    const { dispatch } = store;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`invitations/${guid}/accept`);
      dispatch(getNotifications());
      dispatch(slice.actions.acceptInvitation(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    } finally {
      dispatch(slice.actions.stopLoading());
    }
  };
}

export function declineInvitation(guid: string) {
  return async () => {
    const { dispatch } = store;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`invitations/${guid}/reject`);
      dispatch(getNotifications());
      dispatch(slice.actions.declineInvitation(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    } finally {
      dispatch(slice.actions.stopLoading());
    }
  };
}

export function deleteInvitation(invitationGuid: string) {
  return async (): Promise<ApiResult<void>> => {
    const { dispatch } = store;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.delete(`invitations/${invitationGuid}`);
      dispatch(slice.actions.deleteInvitation(response.data));
      return { success: true, data: undefined };
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      const errorMessage = error instanceof Error ? error.message : 'An unknown error occurred';
      return { success: false, error: new Error(errorMessage) };
    } finally {
      dispatch(slice.actions.stopLoading());
    }
  };
}

export function saveSharePathway(pathwayGuid: string, email: string, mode: number) {
  return async (): Promise<ApiResult<void>> => {
    const { dispatch } = store;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('invitations', {
        pathwayGuid,
        email,
        mode
      });
      dispatch(slice.actions.addInvitation(response.data));
      return { success: true, data: undefined };
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      const errorMessage = error instanceof Error ? error.message : 'An unknown error occurred';
      return { success: false, error: new Error(errorMessage) };
    } finally {
      dispatch(slice.actions.stopLoading());
    }
  };
}
